import type { components } from '@pba/types-openapi-node';

export type MessageDataObject = components['schemas']['Message'];

export type MessageDeliveryStatus = 'failed' | 'sending' | 'sent';

export type MessagePlaceholderDataObject = {
  _id: string;
  chatroom: string;
  createdAt: string;
  payload: MessagePayloadDataObject[];
  status?: MessageDeliveryStatus;
  text?: string;
  type: 'message-placeholder';
  updatedAt: string;
};

export type MessageViewDataObject = MessageDataObject | MessagePlaceholderDataObject;

export const isMessagePlaceholder = (message: MessageViewDataObject): message is MessagePlaceholderDataObject =>
  message.type === 'message-placeholder';

type MessagePayloadDataObject = NonNullable<components['schemas']['Message']['payload']>[number];
